import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/industries/financial-services/page.tsx");
